import { FETCH_PHOTOBOOTH_MEDIA, FETCH_PHOTOBOOTH } from '../actions/actionTypes';

const preState = {
	media: [],
	photobooth: {},
};

const photoBoothReducer = (state = preState, action) => {
	Object.freeze(state);
	const stateDup = { ...state };
	const { type, media, photobooth } = action;

	switch (type) {
		case FETCH_PHOTOBOOTH_MEDIA:
			return { ...stateDup, media: [...media] };
		case FETCH_PHOTOBOOTH:
			return { ...stateDup, photobooth: { ...photobooth } };
		default:
			return stateDup;
	}
};

export default photoBoothReducer;
